import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import FieldValue from './FieldValue';

const useStyles: any = makeStyles((theme: any) => ({
  root: {
    margin: theme.spacing(2, 0),
    border: 1,
  },
  label: {
    [theme.breakpoints.down('xs')]: {
      color: theme.palette.grey['1100'],
    },
  },
  value: {
    fontWeight: 500,
  },
}));

interface Props {
  label: string;
  value?: string | number;
  children?: React.ReactNode;
  dataTestId: string;
}

const FieldLabelAndValue = (props: Props) => {
  const classes = useStyles();
  const { label, value, children, dataTestId } = props;

  return (
    <Grid className={classes.root} container>
      <Grid item xs={12} sm={5}>
        <Typography variant='body1' component='label' className={classes.label}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={7} className={classes.value}>
        {children ? children : <FieldValue dataTestId={dataTestId}>{value}</FieldValue>}
      </Grid>
    </Grid>
  );
};

export default FieldLabelAndValue;
